import React, { Component, type ReactElement } from 'react'
import type LeadershipDto from './LeadershipDto'
import './style.css'

interface Props {
  leader: LeadershipDto
}

class AdvisorCard extends Component<Props> {
  render(): ReactElement {
    const { company, intro, name, position, profile, title } = this.props.leader

    return (
      <div className='advisorCard'>
        <div className='advisorCard-header'>
          <div className='advisorCard-profile'>
            <img
              alt='advisor-profile-picture'
              src={profile}
              srcSet={`${profile} 1x, ${profile} 2x`}
            />
          </div>
          <div className='advisorCard-info'>
            <div className='advisorCard-name'>
              <p>{name}</p>
              <p>{position}</p>
              <p>
                {company} {title}
              </p>
            </div>
          </div>
        </div>
        <div className='advisorCard-content'>
          <p>{intro}</p>
        </div>
      </div>
    )
  }
}

export default AdvisorCard
